import { ADD_QUERY } from "./types";

export const submitLinkedQuery = (panel, screenId, query) => {
    return (dispatch) => {
        panel.linkedPanels.map(x => {
            dispatch({ type: ADD_QUERY, payload: { 
                dispatchId: Date.now() + Math.random() + Math.random(),
                screenId: screenId,
                targetPanelNr: x.linkedPanel,
                query: query,
                dispatchingPanelId: panel.id,
                myInfoFromParent: x
             }});
        });
    }
}

export const submitChildQuery = (panel, screenId, query, selectedItem) => {
    return (dispatch) => {
        panel.childPanels.map(x => {

            let queryOptions = x.foreignColumns.map((c, i) => {
                return {
                    columnName: c,
                    value: selectedItem[x.sourceColumns[i]]
                }
            });
            let queryWithOptions = {
                ...query, queryOptions: queryOptions
            }

            dispatch({ type: ADD_QUERY, payload: { 
                dispatchId: Date.now() + Math.random() + Math.random(),
                screenId: screenId,
                targetPanelNr: x.childPanel,
                query: queryWithOptions,
                dispatchingPanelId: panel.id,
                myInfoFromParent: x,
                myParentRecord: selectedItem
             }});
        });
    }
}